import React from 'react';
import Button from './Button';

export default function EmptyState({ 
  icon: Icon, 
  title, 
  description, 
  action, 
  actionText,
  className = '',
  size = 'md',
  animated = true 
}) {
  const sizeClasses = {
    sm: 'w-12 h-12',
    md: 'w-16 h-16',
    lg: 'w-20 h-20',
    xl: 'w-24 h-24'
  };

  return (
    <div className={`text-center py-12 px-4 ${className}`}>
      <div className={`inline-flex items-center justify-center ${sizeClasses[size]} bg-surface2 rounded-full mb-4 ${
        animated ? 'animate-pulse' : ''
      }`}>
        {Icon && <Icon size={size === 'sm' ? 24 : size === 'lg' ? 40 : size === 'xl' ? 48 : 32} className="text-zinc-400" />}
      </div>
      <h3 className="text-lg font-semibold text-zinc-100 mb-2">{title}</h3>
      <p className="text-zinc-400 mb-6 max-w-md mx-auto leading-relaxed">{description}</p>
      {action && (
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={action} className="min-w-[140px]">
            {actionText || 'Adicionar Item'}
          </Button>
        </div>
      )}
    </div>
  );
}

